<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row class="mt-3">
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="getExpandClasses(parkingGroup)"
						v-for="(parkingGroup, parkingLaneId) in Object.values(parkingRemovalList)" :key="parkingLaneId">
						<div class="collapsible-heading-no-border">
							<div class="d-flex">
								<div class="collapsible-heading__image">
									<b-img fluid v-if="parkingGroup.parkingLaneId !== null"
										:src="parkingGroup.parkingLaneImgUrl"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title">
									{{ parkingGroup.parkingLaneText }}
									<ul>
										<li v-for="(u, itemIndex) in parkingGroup.parkingLocations" :key="itemIndex">
											<small>{{ u.parkingStartAddress.value }} to {{
												u.parkingEndAddress.value }}</small>
											<small>&nbsp;({{ u.parkingRemovalMetres.value }} metres) </small>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<!-- End of desktop -->

					<div v-if="$store.state.isMobile"
						:class="isExpanded(parkingGroup) ? 'collapsible expanded collapsible__lane' : 'collapsible collapsible__lane collapsed'"
						v-for="(parkingGroup, parkingLaneId) in Object.values(parkingRemovalList)" :key="parkingLaneId">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image">
									<b-img v-if="parkingGroup.parkingLaneId !== null"
										:src="parkingGroup.parkingLaneImgUrl"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title">
									{{ parkingGroup.parkingLaneText }}
									<ul>
										<li v-for="(u, itemIndex) in parkingGroup.parkingLocations" :key="itemIndex">
											<small class="collapsible-heading__subtitle">
												{{ u.parkingStartAddress.value }} to {{ u.parkingEndAddress.value }}
												&nbsp;({{ u.parkingRemovalMetres.value }} metres)
											</small>
										</li>
									</ul>
								</div>

							</div>
						</div>
					</div>
					<!-- End of mobile -->

				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'

export default {
	name: 'ViewLaneClosureRequestParkingRemovalListing',
	props: ['renderCounter', 'parkingRemovalList'],
	components: {
	},
	data() {
		return {
			LaneClosureRequest: LaneClosureRequest,
			laneIndexToRemove: null,
		}
	},
	computed: {

	},
	methods: {

		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__lane";
				}
			}
			return "collapsible collapsible__lane collapsed";
		},
		isExpanded(u) {
			if (u) {
				if (typeof u.expand != "undefined") {
					return u.expand;
				}
			}
			return false;
		},
		classes: function (index, uindex) {
			if (this.isEntry(index, uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},

	},
	watch: {
		parkingRemovalList: {
			handler(newList) {
			},
			immediate: true
		},
	},
}
</script>
